import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { FileText, Euro, Loader2 } from "lucide-react";
import { Panel } from "./portalShared";

export function DocumentosTab({ caps }) {
  const [documentos, setDocumentos] = useState(null);
  const [miSalario, setMiSalario] = useState(null);
  useEffect(() => {
    api.get("/rrhh/documentos").then((r) => setDocumentos(r.data || [])).catch(() => setDocumentos([]));
    if (caps?.salario) api.get("/rrhh/nominas/mi-salario").then((r) => setMiSalario(r.data)).catch(() => {});
  }, [caps?.salario]);

  return (
    <div className="space-y-6">
      {miSalario && miSalario.nominas?.length > 0 && (
        <div className="bg-gradient-to-br from-emerald-500/10 to-zinc-900/30 border border-emerald-500/30 rounded-lg overflow-hidden" data-testid="mi-salario">
          <div className="px-4 py-2 text-xs uppercase tracking-wider text-emerald-300 border-b border-emerald-500/20 flex items-center gap-2">
            <Euro className="w-3.5 h-3.5" /> Mi salario · YTD {miSalario.year}
          </div>
          <div className="p-4">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4" data-testid="ytd-cards">
              {[["Bruto acumulado", miSalario.ytd.bruto, "text-emerald-300"], ["Neto cobrado", miSalario.ytd.neto, "text-sky-300"],
                ["IRPF retenido", miSalario.ytd.irpf, "text-amber-300"]].map(([l, v, c]) => (
                <div key={l} className="bg-zinc-900/40 border border-zinc-800 rounded p-3">
                  <div className="text-[10px] uppercase tracking-wider text-zinc-400">{l}</div>
                  <div className={`text-xl font-semibold mt-1 ${c}`}>{Number(v || 0).toFixed(2)} €</div>
                </div>
              ))}
              <div className="bg-zinc-900/40 border border-zinc-700 rounded p-3">
                <div className="text-[10px] uppercase tracking-wider text-zinc-400">Nóminas cobradas</div>
                <div className="text-xl font-semibold mt-1 text-zinc-100">{miSalario.ytd.nominas}</div>
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="text-[10px] uppercase tracking-wider text-zinc-500 border-b border-zinc-800">
                  <tr><th className="text-left p-2">Mes</th><th className="text-right p-2">Bruto</th><th className="text-right p-2">IRPF</th><th className="text-right p-2">SS</th><th className="text-right p-2">Neto</th></tr>
                </thead>
                <tbody>
                  {miSalario.nominas.map((n) => (
                    <tr key={n.id} className="border-b border-zinc-800/40" data-testid={`mi-nom-${n.id}`}>
                      <td className="p-2 font-mono text-xs">{n.year}-{String(n.month).padStart(2, "0")}</td>
                      <td className="p-2 text-right font-mono text-emerald-300">{(n.total_devengado || 0).toFixed(2)} €</td>
                      <td className="p-2 text-right font-mono text-amber-300">{(n.irpf_retenido || 0).toFixed(2)} €</td>
                      <td className="p-2 text-right font-mono text-red-300">{(n.seguridad_social_trabajador || 0).toFixed(2)} €</td>
                      <td className="p-2 text-right font-mono text-sky-300 font-semibold">{(n.liquido_a_percibir || 0).toFixed(2)} €</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      <Panel title={`Mis documentos (${documentos?.length || 0})`} icon={FileText} testid="mis-documentos">
        {documentos === null ? <div className="p-6 text-center text-zinc-500"><Loader2 className="w-5 h-5 animate-spin inline" /></div>
          : documentos.length === 0 ? (
            <div className="text-center py-8 text-zinc-500 text-sm" data-testid="documentos-vacio">Aún no tienes documentos. Cuando RRHH suba tu nómina/contrato aparecerá aquí.</div>
          ) : (
            <div className="divide-y divide-zinc-800/60">
              {documentos.map((d) => (
                <div key={d.id} className="px-3 sm:px-4 py-2.5 flex items-center gap-3 text-sm" data-testid={`mi-doc-${d.id}`}>
                  <span className="text-[10px] px-2 py-0.5 rounded bg-zinc-800 text-zinc-300 capitalize shrink-0">{d.categoria}</span>
                  <div className="flex-1 min-w-0">
                    <div className="text-zinc-200 truncate">{d.titulo}</div>
                    <div className="text-[10px] text-zinc-500 font-mono">{d.fecha_documento || d.subido_at?.slice(0, 10)}</div>
                  </div>
                  <a href={d.url} target="_blank" rel="noopener noreferrer" className="text-amber-300 hover:text-amber-200 text-xs shrink-0" data-testid={`descargar-${d.id}`}>Descargar</a>
                </div>
              ))}
            </div>
          )}
      </Panel>
    </div>
  );
}
